import clsx from 'clsx'
import Image from 'next/image'
import { useRef } from 'react'

import { Button, Text } from '@/shared/ui'

import { UnreadDecorations } from './unread-decorations'

import cls from './open-chat-button.module.scss'

type OpenChatButtonProps = {
	isOpen: boolean
	open: () => void
}

export const OpenChatButton = ({ isOpen, open }: OpenChatButtonProps) => {
	const spanRef = useRef<HTMLSpanElement | null>(null)

	return (
		<Button className={clsx(cls.button, isOpen && cls['button--hide'])} onClick={open} id="ai-open-chat">
			<Image src="/ai-chat.gif" alt={''} width={40} height={40} />
			{/*@ts-ignore*/}
			<Text className={cls.text} ref={spanRef}>
				<span className={cls['text__inner']}>AI-помощник</span>
			</Text>
			<UnreadDecorations />
		</Button>
	)
}
